import { render, staticRenderFns } from "./EformIban.vue?vue&type=template&id=2ad78a0a&scoped=true&"
import script from "./EformIban.vue?vue&type=script&lang=js&"
export * from "./EformIban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad78a0a",
  null
  
)

export default component.exports